import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { useForm } from 'react-hook-form';
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useEffect, useState } from "react";
import { TPipeline } from "./modal";
import { Fetch } from "../../utilities/fetch";
import { useToast } from "../../context/toastProvider";
import { JVDropdown } from "../../shared/JVDropdown";
import { JVInput } from "../../shared/JVInput";
import { TDropdown } from "../../shared/modal";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { format } from "date-fns";

const schema = yup.object({
    statusId: yup.string().required("Status is required*"),
    comment: yup.string().nullable(),
});

interface PipUpdate {
    statusId: number,
    comment?: string,
}

interface Iprops {
    data?: TPipeline,
    open: boolean,
    hideDialog: () => void,
    reload: () => void,
}

type STDropdown = TDropdown & { isPositive: boolean; readyToNext: boolean }

export const ChangeStatus = (props: Iprops) => {
    const { showToast } = useToast();
    const [loading, setLoading] = useState(false);
    const [status, setStatus] = useState<Array<STDropdown>>([]);

    const { control, handleSubmit, formState: { errors }, reset } = useForm<PipUpdate>({
        resolver: yupResolver(schema),
        defaultValues: { statusId: props.data?.statusId, comment: '' },
        shouldFocusError: false
    });

    const loadStatus = async () => {
        const data = await Fetch<STDropdown[]>("pipeline/status/2");
        if (data) {
            setStatus(data);
        }
    }

    useEffect(() => { loadStatus() }, []);
    useEffect(() => {
        reset({ statusId: props.data?.statusId, comment: '' });
    }, [props.data]);

    const saveToDB = async (body: PipUpdate) => {
        const submissionId = props.data?.submissionId;
        if (loading || !submissionId) return;
        setLoading(true);

        const response = await Fetch(`pipeline/change-status/${submissionId}`, {
            method: 'POST',
            body,
            onError: (m) => showToast({ severity: 'error', detail: m })
        });

        if (response) {
            props.hideDialog();
            props.reload();
            showToast({ severity: 'success', detail: "Pipeline Status Changed!" });
        }

        setLoading(false);
    }

    const onHide = () => {
        props.hideDialog();
    }

    function onSubmit(data: PipUpdate) {
        if (!(status.find(f => f.id === Number(data.statusId))?.isPositive) && !data.comment?.trim()) {
            showToast({ severity: 'error', detail: "Write comment for a negative status" });
            return;
        }
        saveToDB(data);
    }

    return (
        <Dialog visible={props.open} style={{ width: '80vw' }} header="Change Pipeline Status" modal className="p-fluid" onHide={onHide}>
            <DataTable size="small" value={props.data ? [props.data] : []} lazy dataKey="id" emptyMessage="No Requirement found.">
                <Column field="candidateName" header="Candidate" />
                <Column field="jobTitle" header="Job Title" />
                <Column field="submital_Date" header="Submitted On" body={(r: TPipeline) => format(new Date(r.submital_Date + 'z'), "MM-dd-yyyy hh:mm a")} />
                <Column field="recruiter" header="Recruiter" />
            </DataTable>

            <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid mt-4">
                <JVDropdown label="Status" name="statusId" optionValue="id" optionLabel="name" control={control} options={status} />
                <JVInput label="Comment" name="comment" control={control} />

                <div className="col-12 md:col-12 flex gap-4 justify-content-end">
                    <Button loading={loading} label="SAVE" type="submit" style={{ width: "100px" }} />
                    <Button className="p-button-outlined surface-200" style={{ width: "100px" }} label="CLOSE"
                        onClick={onHide} type="button" />
                </div>
            </form>
        </Dialog>
    );
}
